<template>
  <div>
    <div class="page-code" :class="{ 'over': over }">


      <div class="inner">
        <div class="code fcc-h">
          <div class="img fcc-h " :class="{ 'item-disalbed': newYearData.status === 1 }">
            <q-r-code-vue :value="qrValue" :size="512" level="H" style="width: 200px;height: 200px"></q-r-code-vue>
            <div class="label fcc" style="color: red !important;" v-if="newYearData.status === 1">
              已核销
            </div>
          </div>
          <div class="p fcc">
            核销时段：{{ newYearData.timeSlot }}
          </div>
        </div>

        <div class="btn-hy fcc" @click="showcheckInBox = true" v-if="newYearData.status !== 1">
          <span>核验</span>
        </div>
      </div>




      <van-overlay :show="showcheckInBox" z-index="999" @click="showcheckInBox = false" @touchstart="handleTouchStart">
        <div class="fcc-h checkin-pop" style="height: 100vh;">
          <div class="fcc-h" style="width:90%;height: 45vh;" @click.stop>
            <div class="logo-wrap fcc">
              <div class="img fcc">
                <img src="../assets/logoicon.png" alt="" srcset="" />
              </div>
            </div>
            <div class="p fcc">
              请在屏幕上盖章
            </div>
          </div>
        </div>
      </van-overlay>

      <div style="position:fixed;left: 110%;top: 110%;width: 0;height: 0;overflow: hidden">
        <!--      <video src="@/assets/audio/duang.mp3"  ref="audio"  controls></video>-->
        <audio id="audioID" ref="audio" class="aud">
          <source src="http://cscec.warnny.com/duang.mp3" type="audio/mp3" />
        </audio>
      </div>

      <van-overlay :show="showLoading">
        <div class="fcc-h " style="height: 100vh;">
          <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
        </div>
      </van-overlay>


      <van-overlay :show="load" @click="load = false">
        <div class="fcc-h " style="height: 100vh;" @click="load = false">
          <div class="brand-logo fcc rotateing">
            <div class="circle"></div>
            <!-- <img src="../assets/8.png" alt="" v-if="zhang"/> -->
            <img src="../assets/logoicon.png" alt="" />
          </div>
        </div>
      </van-overlay>

      <!-- 输入框 -->
      <!-- <van-dialog v-model="showPwdDialog" title="口令" show-cancel-button @confirm="confirm" :lazy-render="false">
        <van-field v-model="pwd" rows="2" autosize autofocus placeholder="请输入口令" show-word-limit class="message" />
      </van-dialog> -->


    </div>
  </div>
</template>
<script>
import {
  checkCode,
  getCode
} from "@/api/api";
import QRCodeVue from 'qrcode.vue';
import { check } from "@/utils/check"

export default {
  components: {
    QRCodeVue
  },
  data() {
    return {

      // 任务结束
      over: true,
      activityId: 0,
      xzCode: '',
      qrValue: 'https://testmobile.shyxs.com.cn' + '/app/yxs-app/activeUser/checkCode/' + this.activityId,

      showPwdDialog: false,
      pwd: '',

      load: false,

      showLoading: false,
      checking: false,
      showcheckInBox: false,

      gaizhangCount: 0,
      newYearData: {},
    }
  },
  async mounted() {
    //获取url参数
    console.log('token', this.$route.query.token);
    console.log('token', this.$route.query.activityId);
    if (this.$route.query.token) {
      await window.localStorage.setItem('token', this.$route.query.token)
    }
    if (this.$route.query.activityId) {
      this.activityId = this.$route.query.activityId
      this.getCodeFun()
    }
  },
  methods: {
    getCodeFun() {
      getCode(this.activityId).then(res => {
        console.log(res)
        this.xzCode = res.data.xzCode
        this.newYearData = res.data
      })
    },

    showcheckInBoxFun() {
      this.showcheckInBox = true
    },
    async handleTouchStart(event) {
      if (event.touches.length != 4) {
        return
      }
      // 获取触摸点的坐标
      let touchArr = []
      for (let i = 0; i < event.touches.length; i++) {
        var touchX = event.touches[i].clientX;
        var touchY = event.touches[i].clientY;
        let touchItem = [touchX, touchY]
        touchArr.push(touchItem)
      }
      let scope = check(touchArr)
      console.log("盖章：", scope)
      if (!scope) {
        // that.$toast("打卡失败，请重试")
        return
      }
      if (scope) {
        if (this.checking) {
          return
        }
        this.checking = true
        this.showcheckInBox = false
        this.load = true

        let self = this
        checkCode(this.activityId).then(res => {
          if (res.success) {
            document.querySelector('audio').play()
            document.getElementById("audioID").play()
            this.load = false
            self.$toast("核销成功")
            self.getCodeFun()
          } else {
            self.$toast(res.message)
          }
        }).finally(f => {
          self.checking = false
        })
      }
    },
  },
}
</script>

<style scoped="scoped" lang="less">
.item-disalbed{
  filter: grayscale(100%);
  canvas{
    opacity: 0.2;
  }
  .label{
    color: red;
  }
}
.qrcode-container img {
  filter: grayscale(100%); /* 将二维码图片转换为灰度 */
  /* 或者使用其他滤镜效果，但要注意不要过度影响识别率 */
}
.brand-logo {
  width: 367px;
  height: 367px;

  margin: 50px auto 22px;
  position: relative;

  .circle {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: url(../assets/8bg.png) center no-repeat;
    background-size: contain;
  }

  img {
    position: relative;
    width: 205px;
    height: 205px;
    display: block;
    object-fit: contain;
  }
}

.rotateing {
  .circle {
    -webkit-animation: circle 3s linear infinite;
    animation: circle 3s linear infinite;
  }
}


@keyframes circle {
  0% {
    -webkit-transform: rotate(0) scale(1.5);
    transform: rotate(0) scale(1.5);

  }

  // 33% {
  // 	-webkit-transform: rotate(720deg) scale(1.5);
  // 	transform: rotate(720deg) scale(1.5);
  // }
  // 67% {
  // 	-webkit-transform: rotate(1080deg) scale(1.5);
  // 	transform: rotate(1080deg) scale(1.5);
  // }
  100% {
    -webkit-transform: rotate(720deg) scale(1.5);
    transform: rotate(720deg) scale(1.5);
  }
}
</style>
